module.exports = __webpack_public_path__ + "static/img/9.5c42fe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/9.jpg
// module id = YAcO
// module chunks = 5